// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"styles_modalBackground__XBRRK","p0Login":"styles_p0Login__3R6UQ","modal":"styles_modal__pGmv0","modalContent":"styles_modalContent__3Vu9A"};